// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f5d64bc","455":"3848b09b","977":"1f7ad681"}[chunkId] + ".chunk.js";
};